// extracted by mini-css-extract-plugin
export default {"container":"DhfbLBl4","backButtonContainer":"JY6H_S2v","backButton":"pTrDhy8s"};